var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 7.5H7.375M3.625 10H7.375M8.625 13.125H2.375C1.68464 13.125 1.125 12.5654 1.125 11.875V3.125C1.125 2.43464 1.68464 1.875 2.375 1.875H5.86612C6.03188 1.875 6.19085 1.94085 6.30806 2.05806L9.69194 5.44194C9.80915 5.55915 9.875 5.71812 9.875 5.88388V11.875C9.875 12.5654 9.31536 13.125 8.625 13.125Z",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.1a33e12fda5165a13438a23cb2b5adba.svg";
export { ForwardRef as ReactComponent };